import React, { useState } from 'react';
import { Button } from '../UI/Button';
import { Link, useNavigate } from 'react-router-dom';
import { Dialog } from '../UI/Dialog';
interface FooterProps {
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
}
export const Footer = ({
  openRegistrationForm,
  openHostSalonForm
}: FooterProps) => {
  const [isNewsletterOpen, setIsNewsletterOpen] = useState(false);
  const navigate = useNavigate();
  const handleJoinNowClick = () => {
    // Navigate to the access points section on the home page
    if (window.location.pathname === '/') {
      // If already on home page, find and scroll to the access points section
      const accessPointsSection = document.querySelector('section.py-16.bg-gray-50');
      if (accessPointsSection) {
        accessPointsSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    } else {
      // If on another page, navigate to home and then to access points
      navigate('/?scrollToAccessPoints=true');
    }
  };
  const footerSections = [{
    title: 'About',
    links: [{
      name: 'Mission',
      path: '/about#vision-mission-values'
    }, {
      name: 'Vision',
      path: '/about#vision-mission-values'
    }, {
      name: 'Values',
      path: '/about#vision-mission-values'
    }, {
      name: 'Team',
      path: '/about'
    }, {
      name: 'Partners',
      path: '/partners'
    }]
  }, {
    title: 'Connect',
    links: [{
      name: 'Join the Salon',
      action: handleJoinNowClick
    }, {
      name: 'Host a Salon',
      path: '/host-salon'
    }, {
      name: 'Partner with Us',
      path: '/partner-with-us'
    }, {
      name: 'Join Our Team',
      path: '/join-team'
    }, {
      name: 'Newsletter',
      path: '#',
      isForm: true,
      formType: 'newsletter'
    }]
  }, {
    title: 'Resources',
    links: [{
      name: 'Blog',
      path: '/blog'
    }, {
      name: 'Toolkits',
      path: '/toolkits'
    }, {
      name: 'Networking Guides',
      path: '/networking-guide'
    }, {
      name: 'FAQs',
      path: '/faq'
    }]
  }, {
    title: 'Legal',
    links: [{
      name: 'Privacy Policy',
      path: '/privacy-policy'
    }, {
      name: 'Terms of Service',
      path: '/terms-of-service'
    }, {
      name: 'Cookie Policy',
      path: '/cookie-policy'
    }]
  }];
  return <footer className="bg-secondary/10 border-t border-secondary/20" data-id="element-693">
      <div className="container mx-auto px-4 py-12" data-id="element-694">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-695">
          <div data-id="element-696">
            <div className="flex items-center" data-id="element-697">
              <div className="h-20" data-id="element-698">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rVLoSkFZL9a8o5YzEX4uvV/Logo_and_Teashirt_branding.png" alt="The Networking Salon Logo" className="h-full" data-id="element-699" />
              </div>
            </div>
            <p className="mt-4 text-secondary" data-id="element-700">
              Where connection unlocks opportunity.
            </p>
            <div className="mt-6" data-id="element-701">
              <Button onClick={handleJoinNowClick} data-id="element-702">Join the Salon</Button>
            </div>
          </div>
          {footerSections.map(section => <div key={section.title} data-id="element-703">
              <h3 className="font-medium text-lg text-secondary-dark" data-id="element-704">
                {section.title}
              </h3>
              <ul className="mt-4 space-y-2" data-id="element-705">
                {section.links.map(link => <li key={link.name} data-id="element-706">
                    {link.isForm ? <a href="#" onClick={e => {
                e.preventDefault();
                if (link.formType === 'newsletter') {
                  setIsNewsletterOpen(true);
                }
              }} className="text-secondary hover:text-primary hover:underline" data-id="element-707">
                        {link.name}
                      </a> : link.action ? <a href="#" onClick={e => {
                e.preventDefault();
                link.action();
              }} className="text-secondary hover:text-primary hover:underline" data-id="element-708">
                        {link.name}
                      </a> : <Link to={link.path} className="text-secondary hover:text-primary hover:underline" data-id="element-709">
                        {link.name}
                      </Link>}
                  </li>)}
              </ul>
            </div>)}
        </div>
        <div className="mt-12 pt-6 border-t border-secondary/20 flex flex-col md:flex-row justify-between items-center" data-id="element-710">
          <p className="text-secondary text-sm" data-id="element-711">
            © {new Date().getFullYear()} The Networking Salon. All rights
            reserved.
          </p>
          <div className="mt-4 md:mt-0 flex space-x-4" data-id="element-712">
            <a href="https://www.linkedin.com/showcase/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="p-2 border border-secondary/30 rounded-full hover:border-primary hover:bg-primary/5 transition-colors" data-id="element-713">
              <div className="w-5 h-5 bg-secondary rounded-full" data-id="element-714"></div>
            </a>
            <a href="https://www.instagram.com/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="p-2 border border-secondary/30 rounded-full hover:border-primary hover:bg-primary/5 transition-colors" data-id="element-715">
              <div className="w-5 h-5 bg-secondary rounded-full" data-id="element-716"></div>
            </a>
            <a href="#" className="p-2 border border-secondary/30 rounded-full hover:border-primary hover:bg-primary/5 transition-colors" data-id="element-717">
              <div className="w-5 h-5 bg-secondary rounded-full" data-id="element-718"></div>
            </a>
          </div>
        </div>
      </div>
      {/* Newsletter Dialog */}
      <Dialog isOpen={isNewsletterOpen} onClose={() => setIsNewsletterOpen(false)} title="Subscribe to Our Newsletter" data-id="element-719">
        <div className="p-6 text-center" data-id="element-720">
          <h3 className="text-xl font-bold mb-4" data-id="element-721">Subscribe on LinkedIn</h3>
          <p className="mb-6" data-id="element-722">
            Stay updated with the latest events, opportunities, and success
            stories.
          </p>
          <div className="flex justify-center mb-6" data-id="element-723">
            <a className="flex flex-col justify-center px-7 py-3 text-center text-white no-underline rounded-2xl bg-[#0A66C2] font-sans w-[200px] h-[32px]" href="https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=6970049734086377472" target="_blank" rel="noopener noreferrer" data-id="element-724">
              Subscribe on LinkedIn
            </a>
          </div>
          <Button variant="outline" onClick={() => setIsNewsletterOpen(false)} data-id="element-725">
            Close
          </Button>
        </div>
      </Dialog>
    </footer>;
};